import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Package } from "lucide-react";
import api, { formatPrice } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";

const STATUS_LABELS = {
  new: { az: "Yeni", en: "New" },
  processing: { az: "Hazırlanır", en: "Processing" },
  shipped: { az: "Göndərildi", en: "Shipped" },
  completed: { az: "Tamamlandı", en: "Completed" },
  cancelled: { az: "Ləğv edildi", en: "Cancelled" },
};

const Account = () => {
  const { user, loading, logout } = useAuth();
  const { t, lang } = useLanguage();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!loading && !user) navigate("/login");
  }, [loading, user, navigate]);

  useEffect(() => {
    if (user) api.get("/my/orders").then(({ data }) => setOrders(data)).catch(() => {});
  }, [user]);

  if (!user) return <div className="max-w-3xl mx-auto px-6 py-32 text-brand-muted">{t("loading")}</div>;

  return (
    <div className="max-w-4xl mx-auto px-6 md:px-12 py-16" data-testid="account-page">
      <div className="flex justify-between items-start mb-12">
        <div>
          <p className="overline mb-2">{t("welcome")}</p>
          <h1 className="font-serif font-light text-4xl tracking-tight">{user.name}</h1>
          <p className="text-sm text-brand-muted mt-2">{user.email}</p>
        </div>
        <button onClick={() => { logout(); navigate("/"); }} data-testid="logout-btn" className="flex items-center gap-2 overline border border-brand-line px-4 py-2 hover:border-brand-ink">
          <LogOut size={16} strokeWidth={1.5} /> {t("logout")}
        </button>
      </div>

      <h2 className="font-serif text-2xl mb-6 flex items-center gap-2"><Package size={20} strokeWidth={1.5} /> {t("my_orders")}</h2>
      {orders.length === 0 ? (
        <p className="text-brand-muted py-10">{t("no_products")}</p>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="border border-brand-line p-6" data-testid={`order-${o.order_number}`}>
              <div className="flex justify-between items-start mb-3">
                <div>
                  <p className="font-mono text-sm">{o.order_number}</p>
                  <p className="text-xs text-brand-muted mt-1">{new Date(o.created_at).toLocaleDateString()}</p>
                </div>
                <div className="text-right">
                  <span className="overline border border-brand-line px-3 py-1">
                    {(STATUS_LABELS[o.status] && STATUS_LABELS[o.status][lang]) || o.status}
                  </span>
                  <p className="font-serif text-xl mt-2">{formatPrice(o.total)}</p>
                </div>
              </div>
              <div className="text-sm text-brand-sub">
                {o.items.map((it, i) => (
                  <span key={i}>{it.name} ×{it.quantity}{i < o.items.length - 1 ? ", " : ""}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Account;
